import React from 'react';
import PropTypes from 'prop-types';
import { FaFilePdf } from 'react-icons/fa';
import { ReactPlannerComponents, ReactPlannerConstants } from 'architecrange';
import { exportFloorplanToPdf } from './export-floorplan-pdf';

const {
  MODE_IDLE,
  MODE_2D_ZOOM_IN,
  MODE_2D_ZOOM_OUT,
  MODE_2D_PAN,
  MODE_WAITING_DRAWING_LINE,
  MODE_DRAGGING_LINE,
  MODE_DRAGGING_VERTEX,
  MODE_DRAGGING_ITEM,
  MODE_DRAWING_LINE,
  MODE_DRAWING_HOLE,
  MODE_DRAWING_ITEM,
  MODE_DRAGGING_HOLE,
  MODE_ROTATING_ITEM
} = ReactPlannerConstants;

const { ToolbarButton } = ReactPlannerComponents.ToolbarComponents;

const MODES_2D = [
  MODE_IDLE,
  MODE_2D_ZOOM_IN,
  MODE_2D_ZOOM_OUT,
  MODE_2D_PAN,
  MODE_WAITING_DRAWING_LINE,
  MODE_DRAGGING_LINE,
  MODE_DRAGGING_VERTEX,
  MODE_DRAGGING_ITEM,
  MODE_DRAWING_LINE,
  MODE_DRAWING_HOLE,
  MODE_DRAWING_ITEM,
  MODE_DRAGGING_HOLE,
  MODE_ROTATING_ITEM
];

export default function ToolbarPdfExportButton({ mode, state }, { translator }) {
  if (!MODES_2D.includes(mode)) return null;

  const onClick = e => {
    e.preventDefault();
    let name = `floorplan-${Date.now()}.pdf`;
    name = window.prompt(translator.t('Insert output filename'), name);
    if (!name) return;
    if (!name.toLowerCase().endsWith('.pdf')) name += '.pdf';
    exportFloorplanToPdf(state, name).catch(err => {
      console.error(err);
      window.alert(err.message || String(err));
    });
  };

  return (
    <ToolbarButton active={false} tooltip={translator.t('Export PDF (walls)')} onClick={onClick}>
      <FaFilePdf />
    </ToolbarButton>
  );
}

ToolbarPdfExportButton.propTypes = {
  mode: PropTypes.string.isRequired,
  state: PropTypes.object.isRequired
};

ToolbarPdfExportButton.contextTypes = {
  translator: PropTypes.object.isRequired
};
